import axios from 'axios'
import { API_URL } from '../config'

const securedAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

const plainAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

securedAxios.interceptors.request.use((config: any) => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers,
      'X-CSRF-TOKEN': localStorage.csrf,
    }
  }
  config.headers = {
    ...config.headers,
    Authorization: localStorage.access,
  }
  return config
})

securedAxios.interceptors.response.use(undefined, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    // In case 401 is caused by expired access cookie - we'll do refresh request
    return plainAxios
      .post(
        '/sessions/refresh',
        {},
        {
          headers: {
            // 'X-CSRF-TOKEN': localStorage.csrf,
            'X-Refresh-Token': localStorage.refresh,
          },
        }
      )
      .then(response => {
        localStorage.csrf = response.data.csrf
        localStorage.access = response.data.access
        localStorage.refresh = response.data.refresh
        // And after successful refresh - repeat the original request
        let retryConfig = error.response.config
        retryConfig.headers['X-CSRF-TOKEN'] = localStorage.csrf
        retryConfig.headers['Authorization'] = localStorage.access
        return plainAxios.request(retryConfig)
      })
      .catch(error => {
        delete localStorage.csrf
        delete localStorage.access
        // redirect to signin in case refresh request fails
        window.location.href = '/login'
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
})

export { securedAxios, plainAxios }
